<script>
export default 
{
    name: 'checkbox-button',

    props:
    {
        value: Boolean,
        color: {
            type: String,
            default: '#FF3366',
        },
    },

    computed:
    {
        safeColor()
        {
            return this.color || '#ff3366'
        }
    },

    watch:
    {
        value(val)
        {
            this.selected = val
        },

        safeColor:
        {
            handler: 'setColor',
            immediate: true,
        },
    },

    methods:
    {
        toggle()
        {
            this.selected = !this.selected
            this.$emit('input', this.selected)
        },

        setColor()
        {
            this.$nextTick(() => {
                const el = this.$parent.$el
                if (el) {
                    el.style.setProperty('--checkbox-color', this.safeColor)
                }
            })
        },
    },

    data()
    {
        return {
            uid: 'checkbox-button-' + this._uid,
            selected: this.value,
        }
    }
}
</script>

<template>
<block-button :id="uid" class="checkbox-button" @click="toggle" :class="{ 'selected': selected }">
    <checkmark v-model="selected"></checkmark>
    <span>
        <slot></slot>
    </span>
</block-button>
</template>

<style lang="scss">
button.btn.checkbox-button {
    color: var(--checkbox-color);
    border: 1px solid var(--checkbox-color);

    span {
        font-family: 'ProximaNova';
    }

    &:hover, &.selected {
        color: white;
        background-color: var(--checkbox-color);
    }

}
</style>



// WEBPACK FOOTER //
// src/components/elements/CheckboxButton.vue